import COPY from "../content/publicPageCopy.json";
import SEO from "./SEO";

const TONES = {
  light: {
    wrap: "bg-white dark:bg-slate-950 border-t border-slate-200 dark:border-slate-800",
    eyebrow: "text-teal-700 dark:text-teal-400", h: "text-slate-900 dark:text-white",
    p: "text-slate-600 dark:text-slate-400", dot: "bg-teal-600",
  },
  dark: {
    wrap: "border-t border-white/10", eyebrow: "text-emerald-400", h: "text-white", p: "text-slate-400", dot: "bg-emerald-400",
  },
};

// Long-form, page-specific copy for public pages. The same text is baked into static HTML at build time
// (scripts/build-seo-pages.js) so crawlers that don't run JavaScript read it too.
export const PublicPageCopy = ({ page, tone = "light", withSeo = false }) => {
  const c = COPY[page];
  if (!c) return null;
  const t = TONES[tone];
  return (
    <section className={`${t.wrap} px-6 py-16 lg:py-20`} aria-labelledby={`about-${page}`} data-testid={`page-copy-${page}`}>
      {withSeo && <SEO title={c.title} description={c.description} path={c.path} />}
      <div className="mx-auto max-w-5xl">
        <p className={`text-xs font-mono uppercase tracking-[0.16em] ${t.eyebrow}`}>{c.eyebrow}</p>
        <h2 id={`about-${page}`} className={`mt-3 text-2xl md:text-3xl font-extrabold font-manrope tracking-tight ${t.h}`}>{c.heading}</h2>
        <p className={`mt-4 max-w-3xl text-base leading-relaxed ${t.p}`}>{c.intro}</p>
        <div className="mt-10 grid gap-x-12 gap-y-9 md:grid-cols-2">
          {c.sections.map((s) => (
            <div key={s.heading}>
              <h3 className={`text-base md:text-lg font-bold font-manrope ${t.h}`}>{s.heading}</h3>
              {s.body && <p className={`mt-2 text-sm leading-relaxed ${t.p}`}>{s.body}</p>}
              {s.bullets && (
                <ul className="mt-3 space-y-2">
                  {s.bullets.map((b) => (
                    <li key={b} className={`flex gap-2.5 text-sm leading-relaxed ${t.p}`}>
                      <span className={`mt-2 h-1.5 w-1.5 shrink-0 rounded-full ${t.dot}`} />{b}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
